'use client';

import { useContext, useMemo } from 'react';

import { FilterFacetsContext } from '@/contexts/filterFacetsContext';

export const useFilterFacets = () => {
  const context = useContext(FilterFacetsContext);

  if (!context) {
    throw new Error(
      'useFilterFacets must be used within a FilterFacetsProvider'
    );
  }

  return context;
};

export const useFacetOptions = <T extends { id: string }>(
  propertyName: string,
  options: T[]
): T[] => {
  const context = useContext(FilterFacetsContext);
  const allowed = context?.facets?.[propertyName];
  return useMemo(
    () => (allowed ? options.filter((o) => allowed.has(o.id)) : options),
    [allowed, options]
  );
};
